import {Paper, PaperProps, styled} from "@mui/material";

export const LoginContainer = styled('div')(() => {
    return {
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'auto',
        paddingBottom: '7rem'
    }
});

export const InputContainer = styled((props: PaperProps) =>
    <Paper {...props} elevation={0}/>
)(() => {
    return {
        marginBottom: '1.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '2.25rem',
        width: '100%',
        maxWidth: '30rem',
        zIndex: '1',
        gap: '1rem',

        '& .Mui-focused': {
            outline: 'none',
        },
    }
});
